import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function relatorioAssuntoCassificacaoEstruturaReducer(state = initialState.relatorioAssuntoCassificacaoEstrutura, action){
    switch(action.type) {
        case types.RELAT_ASSUNTO_POR_NATUREZA_ESTRUTURA:
            
            return action.relatorioAssuntoCassificacaoEstrutura;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/relatorioAssuntoClassificacaoEstruturaReducer.js
 **/